<ng-template #pageActionBarLeft>
  <bread-crum class="tpo-bread-crumb"></bread-crum>
</ng-template>

<ng-template #pageActionBarMiddle>
  @if (webPreferences && showFilter) {
    <tpo-pipeline-filter
      [activeFilter]="filter"
      [selectedStageGroup]="selectedStageGroup"
      (applyFiltersClicked)="onPipelineFilterChanged($event)"
      (stageGroupChanged)="onStageGroupChanged($event)">
    </tpo-pipeline-filter>
  }
</ng-template>

<ng-template #pageActionBarRight>
  <div class="d-flex hide-on-mobile">
    <div ngbDropdown class="d-inline-block dropdown" placement="bottom-end">
      <button class="btn btn-primary d-flex align-items-center me-2" id="tpoPipelineViewDropdown"
        style="border-radius:15px" ngbDropdownToggle>
        <span class="flex-grow-1 text-center px-2 truncate-10vw">
          {{ pipelineView || 'Select a View' }}
        </span>
        <i class="fa-solid fa-caret-down ms-2"></i>
      </button>

      <ul class="dropdown-menu cursor" ngbDropdownMenu aria-labelledby="tpoPipelineViewDropdown">
        <li ngbDropdownItem (click)="pipelineView=''; onPipelineViewChanged()">
          -- Select a View --
        </li>

        @for (savedNamedView of savedNamedViews; track savedNamedView) {
          <li ngbDropdownItem class="d-flex align-items-center"
            (click)="pipelineView = savedNamedView; onPipelineViewChanged()">
            <span class="flex-grow-1 me-2 truncate-10vw" [ngbTooltip]="savedNamedView" placement="left">
              {{ savedNamedView }}
            </span>
            <span role="button" class="me-2"
              [ngbTooltip]="isDefaultView(savedNamedView) ? 'Clear default view' : 'Set as default view'" placement="left"
              (click)="toggleDefaultView(savedNamedView); $event.stopPropagation()">
              <i class="cursor text-warning" [ngClass]="isDefaultView(savedNamedView) ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
            </span>
            <span role="button" [ngbTooltip]="'Delete'" placement="left"
              (click)="deletePipelineView(savedNamedView); $event.stopPropagation()">
              <i class="fa-solid fa-trash-alt cursor text-danger"></i>
            </span>
          </li>
        }
      </ul>
    </div>

    <button class="btn btn-primary" type="button" (click)="openSaveViewModal()" style="width: max-content;">
      Save View As ...
    </button>
  </div>
</ng-template>

<ng-template #mainContent>
  <!-- Stats Summary Bar -->
  <div class="col-12">
    <div class="stats-summary-bar">
      <div class="stat-card">
        <div class="stat-icon-wrapper pipeline-value">
          <i class="fas fa-chart-line"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">Pipeline Value</div>
          <div class="stat-value-row">
            <span class="stat-count">{{loanCount}}</span>
            <span class="stat-amount">{{formattedTotalPipelineDollarValue}}</span>
          </div>
          <div class="stat-description">Current Pipeline</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon-wrapper upcoming-closing">
          <i class="fas fa-calendar-check"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">Upcoming Closings</div>
          <div class="stat-value-row">
            <span class="stat-count">{{upcomingClosingCount}}</span>
            <span class="stat-amount">{{formattedtotalLoanAmountUpcoming}}</span>
          </div>
          <div class="stat-description">Loans closing in 15 days</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon-wrapper lock-expiring">
          <i class="fas fa-lock-open"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">Locks Expiring</div>
          <div class="stat-value-row">
            <span class="stat-count">{{lockExpiringCount}}</span>
            <span class="stat-amount">{{formattedtotalLoanAmountLockExpiring}}</span>
          </div>
          <div class="stat-description">Locks expiring in 7 days</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pipeline Table -->
  <div class="col-12">
    @if (!loadingPipeline) {
      @if (pipelineData) {
        <pipeline-table-v2
          [pipelineData]="pipelineData"
          [isTpoUser]="true"
          [webPreferences]="webPreferences"
          [filter]="filter"
          (pipelineFilterChanged)="onPipelineFilterChanged($event)"
          (columnsNeedRefresh)="onColumnsNeedRefresh()"
          (loanDetailsClicked)="onLoanDetailsClicked($event)">
        </pipeline-table-v2>
      }
    }
    @if (loadingPipeline) {
      <loading-indicator [loadingMessage]="'Loading pipeline, please wait...'"
        [customHeight]="'70vh'" [useTransparentBg]="false">
      </loading-indicator>
    }
  </div>
</ng-template>

<tpo-page-template [pageMainContentTemplate]="mainContent" [pageActionBarLeftContentTemplate]="pageActionBarLeft"
  [pageActionBarMiddleContentTemplate]="pageActionBarMiddle"
  [pageActionBarRightContentTemplate]="pageActionBarRight">
</tpo-page-template>
